import { useContext, useCallback } from "react";

import Swal from "sweetalert2";

import { validNotNull } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";
import MaskService from "../../../../utils/mask/maskService";
import { formatDate } from "../../../../utils/formatDate";

import {
  createVenda,
  updateVenda,
} from "../../../../repositories/qerpapi/erp/vendas/v1/VendasRepository";

import { VendaRapidaContext } from "../contexts/VendaRapidaContext";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import {
  consultCreditLimit,
  consultOverdueBills,
  findCliente,
} from "../../../../repositories/qerpapi/erp/prouser/v1/ClienteRepository";
import { findCaixaTerminais } from "../../../../repositories/qerpapi/erp/vendas/v1/CaixaTerminaisRepository";
import { findOperadoras } from "../../../../repositories/qerpapi/erp/financeiro/OperadorasRepository";
import { findBandeiras } from "../../../../repositories/qerpapi/erp/financeiro/BandeirasRepository";
import { findAgencia } from "../../../../repositories/qerpapi/erp/financeiro/AgenciasRepository";
import { findTipoPagamento } from "../../../../repositories/qerpapi/erp/prouser/v1/TipoPagamento";
import {
  findPermissionsForOrder,
  findUsuarios,
} from "../../../../repositories/qerpapi/erp/acesso/v1/UsuarioRepository";
import { findVendedores } from "../../../../repositories/qerpapi/erp/vendas/v1/VendedoresRepository";
import { GlobalVariables } from "../../../../GlobalVariables";
import { findVendas } from "../../../../repositories/qerpapi/erp/vendas/v1/VendasRepository";
import { findConfigurationV3 } from "../../../../repositories/qerpapi/v3/ConfigurationRepository";

export default function useVendaRapidaController() {
  const {
    clientCpf,
    sellerCode,
    setSellerCode,
    sellerName,
    setSellerName,
    setClientCpf,
    clientName,
    setClientName,
    productCode,
    setProductCode,
    productDescription,
    setProductDescription,
    productPrice,
    setProductPrice,
    productQuantity,
    setProductQuantity,
    setProductImage,
    tableRows,
    setTableRows,
    orderTotal,
    setOrderTotal,
    setOrderTotalNoDiscount,
    updatedValue,
    setUpdatedValue,
    productDiscount,
    setProductDiscount,
    setDisabledAddButton,
    sellerComission,
    setSellerComission,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    selectedPaymentType,
    setSelectedPaymentType,
    selectedBankAccount,
    setSelectedBankAccount,
    setBankAccountsList,
    setBankAccounts,
    onTotalDiscount,
    setOnTotalDiscount,
    toPayValue,
    setToPayValue,
    isPercentage,
    setIsPercentage,
    setModalFinishOpen,
    setSellerErrors,
    setClientErrors,
    paymentValue,
    setPaymentValue,
    totalPayment,
    setTotalPayment,
    troco,
    setTroco,
    paymentRows,
    setPaymentRows,
    setPaymentTotal,
    setPaymentErrors,
    clientId,
    setClientId,
    setSellerCpfCnpj,
    setModalVrfLoading,
    setProductCodeAux,
    productStorageCode,
    setProductStorageCode,
    setButtonNewOrderView,
    setStoredOrderCode,
    setDisplayNoneTransmit,
    setFinishButtonView,
    disabledPaymentActions,
    setDisabledPaymentActions,
    setGeneralDiscount,
    paymentTypes,
    itemsDiscount,
    setItemsDiscount,
    setTotalDiscountView,
    productUnity,
    setProductUnity,
    setModalChequeCartaoOpen,
    cardDocnsu,
    setCardDocnsu,
    cardAuthorizationNumber,
    setCardAuthorizationNumber,
    setCheckErrors,
    setCardErrors,
    cardSelectedBandeira,
    setCardSelectedBandeira,
    cardSelectedOperadora,
    setCardSelectedOperadora,
    setIsCheck,
    setCheckBanda,
    checkNumber,
    setCheckNumber,
    checkDepositDate,
    setCheckDepositDate,
    checkCpfCnpj,
    setCheckCpfCnpj,
    checkBankCode,
    setCheckBankCode,
    checkAgency,
    setCheckAgency,
    checkCurrentAccount,
    setCheckCurrentAccount,
    checkAccountHolder,
    setCheckAccountHolder,
    setEditRowCheckOrCard,
    setDialogSelectCaixaOpen,
    selectedCaixa,
    setSelectedCaixa,
    sellerInfos,
    setSellerInfos,
    setSellerCodeAux,
    productInfos,
    setProductInfos,
    clientInfos,
    setClientInfos,
    setClientCpfAux,
    productConversionFactor,
    setProductConversionFactor,
    paymentMethods,
    setIsLoading,
    setCardOperadorasList,
    setCardBandeirasList,
    setPaymentTypes,
    setProductBruteCost,
    productBruteCost,
    setModalAuthenticateWarnings,
    setModalAuthenticateOpen,

    userMaximumDiscountPercentage,
    setUserMaximumDiscountPercentage,
  } = useContext(VendaRapidaContext);

  const { queryParams, tempQueryParams, setTempQueryParams } =
    useContext(QueryParamsContext);

  const resetModalCardOrCheck = () => {
    setEditRowCheckOrCard(null);

    // cartao
    setCardAuthorizationNumber("");
    setCardDocnsu("");
    setCardSelectedBandeira(null);
    setCardSelectedOperadora(null);
    setCardErrors({});

    // cheque
    setCheckErrors({});
    setCheckBanda("");
    setCheckNumber("");
    setCheckDepositDate("");
    setCheckCpfCnpj("");
    setCheckBankCode("");
    setCheckAgency("");
    setCheckCurrentAccount("");
    setCheckAccountHolder("");
  };

  const resetPage = async (handleFocus = () => {}) => {
    if (tempQueryParams?.saleId) {
      setTempQueryParams({});
    }
    resetPaymentInputs();
    resetProductInputs();
    resetModalCardOrCheck();
    setStandardPayment();

    //reset botoes
    setButtonNewOrderView(false);
    setDisplayNoneTransmit(false);
    setFinishButtonView(true);
    setDisabledPaymentActions(false);

    //reset codigo da venda guardado
    setStoredOrderCode(null);

    //reset descontos
    setGeneralDiscount("0,00");
    setItemsDiscount("0,00");

    //reset cliente
    setClientInfos(null);
    setClientCpfAux("");

    //reset table
    setTableRows([]);
    setOrderTotal("0,00");
    setOrderTotalNoDiscount("0,00");

    //reset pagamento
    setOnTotalDiscount("0,00");
    setSelectedPaymentType(null);
    setSelectedPaymentMethod(null);
    setSelectedBankAccount(null);
    setBankAccountsList([]);
    setBankAccounts([]);
    setPaymentValue("0,00");
    setToPayValue("0,00");
    setIsPercentage(false);
    setTotalPayment("0,00");
    setTroco("0,00");
    setPaymentRows([]);
    setPaymentTotal("0,00");
    setPaymentErrors({});

    setModalFinishOpen(false);

    try {
      setIsLoading(true);
      const [, , agencias] = await Promise.all([
        getDefaultClient(),
        getSeller(true),
        findAgencia(
          queryParams?.empresa_cnpj,
          queryParams?.usuario_id,
          "banco"
        ),
      ]);
      if (agencias?.data) setBankAccountsList(agencias.data);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
    setTimeout(handleFocus, 300);
  };

  const getSeller = useCallback(
    async (resetPage = false) => {
      if (
        !queryParams.empresa_cnpj ||
        !queryParams.idversao ||
        !queryParams.usuario_id ||
        resetPage
      )
        return;

      const user = await findUsuarios(
        queryParams.empresa_cnpj,
        queryParams.usuario_id
      );

      if (!user.success) throw new Error("Usuário não encontrado");

      let sellerId;
      if (queryParams?.idversao !== "16")
        sellerId = user.data?.idvendedor || null;
      else sellerId = 14;

      if (sellerId)
        var seller = await findVendedores({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: sellerId,
        });

      if (!seller?.success || seller?.data?.ativo !== "S") {
        notify(
          "Vendedor padrão não encontrado no sistema ou se encontra inativo.",
          true,
          "warning"
        );
        throw new Error("Vendedor padrão não encontrado ou inativo.");
      } else setSellerInfos(seller.data);
    },
    [
      queryParams.empresa_cnpj,
      queryParams.idversao,
      queryParams.usuario_id,
      setSellerInfos,
    ]
  );

  const resetProductInputs = () => {
    setProductInfos(null);
    setProductDiscount("0,00");
  };

  const resetPaymentInputs = () => {
    setSelectedPaymentType(null);
    setPaymentValue("0,00");
    setSelectedBankAccount(null);
  };

  const editModalChequeCartao = (idtipopagto, row) => {
    setIsCheck(false);
    if (idtipopagto === 49) setIsCheck(true);
    setEditRowCheckOrCard(row);
    setModalChequeCartaoOpen(true);
  };

  const editPaymentRow = (idtipopagto, index) => {
    let rows = [...paymentRows];
    const rowToEdit = paymentRows[index];
    const copy = { ...rowToEdit };

    if (!(rowToEdit?.parcelas_condicao_pgto || []).length) {
      return notify(
        "A forma de pagamento selecionada não possui condições de pagamento."
      );
    }

    if (
      (copy?.qtdepagtos || 0).toString() !==
      (copy?.parcelas_condicao_pgto.length).toString()
    ) {
      return notify(
        "A quantidade de parcelas não corresponde às condições de pagamento."
      );
    }

    copy.parcelasCondicaoPgto = (
      selectedPaymentMethod?.parcelas_condicao_pgto || []
    ).map((item) => {
      return {
        id: item.id,
        numParcela: item.ni_numero_parcela,
        diaParcela: item.ni_parcelas,
      };
    });

    if (idtipopagto === 49) {
      copy.cheque = {
        ...copy.cheque,
        sn_banco: checkBankCode ?? "",
        sn_conta: checkCurrentAccount ?? "",
        sn_agencia: checkAgency ?? "",
        sn_correntista: checkAccountHolder ?? "",
        sn_numero: checkNumber ?? "",
        sn_cpfcgc: checkCpfCnpj.replace(/[^0-9]+/g, "") ?? "",
        dt_datadeposito: checkDepositDate.replaceAll("-", "/") ?? "",
      };
    } else {
      copy.cartao = {
        ...copy.cartao,
        sn_autorizacao: cardAuthorizationNumber ?? "",
        sn_docnsu: cardDocnsu ?? "",
        id_operadora: cardSelectedOperadora?.id ?? "",
        id_bandeira: cardSelectedBandeira?.id ?? "",
      };
    }

    rows[index] = copy;

    setPaymentRows(rows);
    resetModalCardOrCheck();
    setModalChequeCartaoOpen(false);
  };

  const addPaymentRowCheckOrCard = (closeModalFunction = () => {}) => {
    let newRow = {};

    // se for cheque...
    if (selectedPaymentType?.id === 49) {
      let validateCheckPaymentRow = validNotNull([
        // {
        //   key: "selectedPaymentType",
        //   value: selectedPaymentType,
        // },
        // {
        //   key: "checkCpfCnpj",
        //   value: checkCpfCnpj,
        // },
      ]);

      if (checkCpfCnpj.length !== 14 && checkCpfCnpj.length !== 18) {
        validateCheckPaymentRow.errorsValidation.checkCpfCnpj =
          "Número digitado inválido.";
        validateCheckPaymentRow.error = true;

        notify("CPF/CNPJ inválido.");
      }

      setCheckErrors({
        ...validateCheckPaymentRow.errorsValidation,
      });

      if (validateCheckPaymentRow.error || removeMaskDecimal(paymentValue) <= 0)
        return;

      newRow = {
        index: paymentRows.length,
        numero: paymentRows.length + 1,
        tipopagto: selectedPaymentType.descricao,
        formapagto: selectedPaymentMethod.descricao,
        valor: paymentValue,
        idtipopagto: parseInt(selectedPaymentType.id),
        carteira: selectedPaymentType.carteira,
        idformapagto: selectedPaymentMethod.id,
        qtdparcelas: parseInt(selectedPaymentMethod.qtdepagtos),
        indicador: selectedPaymentType.carteira,
        cheque: {
          sn_banco: checkBankCode ?? "",
          sn_conta: checkCurrentAccount ?? "",
          sn_agencia: checkAgency ?? "",
          sn_correntista: checkAccountHolder ?? "",
          sn_numero: checkNumber ?? "",
          sn_cpfcgc: checkCpfCnpj.replace(/[^0-9]+/g, "") ?? "",
          dt_datadeposito: checkDepositDate.replaceAll("-", "/") ?? "",
        },
      };
    } else {
      // se for cartao...
      const validateCardPaymentRow = validNotNull([
        // {
        //   key: "authorizationNumber",
        //   value: authorizationNumber,
        // },
        // {
        //   key: "docnsu",
        //   value: docnsu,
        // },
        // {
        //   key: "selectedBandeira",
        //   value: selectedBandeira,
        // },
        // {
        //   key: "selectedOperadora",
        //   value: selectedOperadora,
        // },
      ]);

      setCardErrors({
        ...validateCardPaymentRow.errorsValidation,
      });

      if (validateCardPaymentRow.error || removeMaskDecimal(paymentValue) <= 0)
        return;

      newRow = {
        index: paymentRows.length,
        numero: paymentRows.length + 1,
        tipopagto: selectedPaymentType.descricao,
        carteira: selectedPaymentType.carteira,
        formapagto: selectedPaymentMethod.descricao,
        valor: paymentValue,
        idtipopagto: parseInt(selectedPaymentType.id),
        idformapagto: selectedPaymentMethod.id,
        qtdparcelas: parseInt(selectedPaymentMethod.qtdepagtos),
        indicador: selectedPaymentType.carteira,
        cartao: {
          sn_autorizacao: cardAuthorizationNumber ?? "",
          sn_docnsu: cardDocnsu ?? "",
          id_operadora: cardSelectedOperadora?.id ?? "",
          id_bandeira: cardSelectedBandeira?.id ?? "",
        },
      };
    }

    newRow.parcelasCondicaoPgto = (
      selectedPaymentMethod?.parcelas_condicao_pgto || []
    ).map((item) => {
      return {
        id: item.id,
        numParcela: item.ni_numero_parcela,
        diaParcela: item.ni_parcelas,
      };
    });

    if (selectedPaymentType.carteira === "N") {
      newRow.agencia = selectedBankAccount?.id;
    }

    setPaymentRows((prev) => [...prev, newRow]);

    setTotalPayment((prev) =>
      MaskService.toMask(
        "decimal",
        (removeMaskDecimal(prev) + removeMaskDecimal(paymentValue)).toFixed(2)
      )
    );

    resetPaymentInputs();
    setStandardPayment();
    resetModalCardOrCheck();
    closeModalFunction();
  };

  const addPaymentRow = () => {
    let newRow = {};

    const validatePaymentRow = validNotNull([
      {
        key: "selectedPaymentType",
        value: selectedPaymentType,
      },
      {
        key: "selectedPaymentMethod",
        value: selectedPaymentMethod,
      },
      {
        key: "paymentValue",
        value: paymentValue,
      },
    ]);

    if (!(selectedPaymentMethod?.parcelas_condicao_pgto || []).length) {
      return notify(
        "A forma de pagamento selecionada não possui condições de pagamento."
      );
    }

    if (
      (selectedPaymentMethod?.qtdepagtos || 0).toString() !==
      (selectedPaymentMethod?.parcelas_condicao_pgto.length).toString()
    ) {
      return notify(
        "A quantidade de parcelas não corresponde às condições de pagamento."
      );
    }

    if (selectedPaymentType.carteira === "N") {
      if (!selectedBankAccount) {
        Swal.fire({
          icon: "error",
          text: "A conta bancária não pode ficar vazia.",
          showConfirmButton: true,
          confirmButtonText: "OK",
        });
        return;
      }
    }

    setPaymentErrors({
      ...validatePaymentRow.errorsValidation,
    });

    if (!validatePaymentRow.error) {
      if (
        parseInt(selectedPaymentType.id) >= 47 &&
        parseInt(selectedPaymentType.id) <= 49
      ) {
        setIsCheck(false);
        if (parseInt(selectedPaymentType.id) === 49) setIsCheck(true);
        setModalChequeCartaoOpen(true);
        return;
      } else {
        newRow = {
          index: paymentRows.length,
          numero: paymentRows.length + 1,
          tipopagto: selectedPaymentType.descricao,
          carteira: selectedPaymentType.carteira,
          formapagto: selectedPaymentMethod.descricao,
          valor: paymentValue,
          idtipopagto: parseInt(selectedPaymentType.id),
          idformapagto: selectedPaymentMethod.id,
          qtdparcelas: parseInt(selectedPaymentMethod.qtdepagtos),
          indicador: selectedPaymentType.carteira,
          parcelasCondicaoPgto: (
            selectedPaymentMethod?.parcelas_condicao_pgto || []
          ).map((item) => {
            return {
              id: item.id,
              numParcela: item.ni_numero_parcela,
              diaParcela: item.ni_parcelas,
            };
          }),
          ...(selectedPaymentType.carteira === "N" && {
            agencia: selectedBankAccount?.id,
          }),
        };
      }

      setPaymentRows((prev) => [...prev, newRow]);

      setTotalPayment((prev) =>
        MaskService.toMask(
          "decimal",
          (removeMaskDecimal(prev) + removeMaskDecimal(paymentValue)).toFixed(2)
        )
      );

      resetPaymentInputs();
      setStandardPayment();
    }
  };

  const changeUStoBR = (value = "") => {
    if (value.length > 0) {
      value = value.replace(",", "");

      return value.replace(".", ",");
    }
    return value;
  };

  const handleTotalPayment = useCallback(() => {
    if (removeMaskDecimal(totalPayment) > removeMaskDecimal(toPayValue)) {
      let newTroco =
        removeMaskDecimal(toPayValue) - removeMaskDecimal(totalPayment);

      setTroco(MaskService.toMask("decimal", newTroco.toFixed(2)));
    } else {
      setTroco("0,00");
    }
  }, [totalPayment, toPayValue, setTroco]);

  const handleOnTotalDiscount = useCallback(() => {
    if (isPercentage) {
      if (removeMaskDecimal(onTotalDiscount) > 100.0) {
        Swal.fire({
          icon: "error",
          text: "A porcentagem de desconto não pode ser maior que 100%.",
          showConfirmButton: true,
          confirmButtonText: "OK",
        });

        setOnTotalDiscount("0,00");
        return;
      }
    } else {
      if (removeMaskDecimal(onTotalDiscount) > removeMaskDecimal(orderTotal)) {
        Swal.fire({
          icon: "error",
          text: "O desconto não pode ser maior que o valor total.",
          showConfirmButton: true,
          confirmButtonText: "OK",
        });

        setOnTotalDiscount("0,00");
        return;
      }
    }

    let newTotal;
    const discountValue = isPercentage
      ? (removeMaskDecimal(onTotalDiscount) / 100) *
        removeMaskDecimal(orderTotal)
      : removeMaskDecimal(onTotalDiscount);

    const average = discountValue / removeMaskDecimal(orderTotal);

    let blockDiscount = false;
    tableRows.forEach((product) => {
      const originalTotal =
        (removeMaskDecimal(product.precovenda) -
          removeMaskDecimal(product.descvalor)) *
        product.qtd;
      const proportionalDiscount = (average * originalTotal) / product.qtd;

      const givenDiscount =
        removeMaskDecimal(product.descvalor) + proportionalDiscount;

      let maximumDiscount =
        (removeMaskDecimal(userMaximumDiscountPercentage) / 100) *
        removeMaskDecimal(product.precovenda);

      if (givenDiscount > maximumDiscount) blockDiscount = true;
    });

    if (blockDiscount) {
      setOnTotalDiscount("0,00");
      return notify("Desconto máximo excedido.");
    }

    newTotal = isPercentage
      ? (newTotal =
          removeMaskDecimal(orderTotal) -
          (removeMaskDecimal(onTotalDiscount) / 100) *
            removeMaskDecimal(orderTotal))
      : (newTotal = removeMaskDecimal(orderTotal) - discountValue);

    setToPayValue(MaskService.toMask("decimal", newTotal.toFixed(2)));
    setPaymentValue(MaskService.toMask("decimal", newTotal.toFixed(2)));
    setTotalDiscountView(
      MaskService.toMask("decimal", discountValue.toFixed(2))
    );
  }, [
    onTotalDiscount,
    isPercentage,
    orderTotal,
    setOnTotalDiscount,
    setPaymentValue,
    setToPayValue,
    userMaximumDiscountPercentage,
    tableRows,
    setTotalDiscountView,
  ]);

  const handleUpdatedValue = useCallback(() => {
    let result;
    let givenDiscount = removeMaskDecimal(productDiscount);
    let maximumDiscount =
      (removeMaskDecimal(userMaximumDiscountPercentage) / 100) *
      removeMaskDecimal(productPrice, 4);

    if (givenDiscount > maximumDiscount) {
      Swal.fire({
        icon: "error",
        text: "Você está tentando dar um valor de desconto do qual não possui permissão.",
        showConfirmButton: true,
        confirmButtonText: "OK",
      });

      result = removeMaskDecimal(productPrice, 4);
      setProductDiscount("0,00");
    } else {
      result =
        (removeMaskDecimal(productPrice, 4) - givenDiscount) * productQuantity;
    }

    setUpdatedValue(MaskService.toMask("decimal", result.toFixed(2)));
  }, [
    productDiscount,
    productQuantity,
    productPrice,
    setProductDiscount,
    setUpdatedValue,
    userMaximumDiscountPercentage,
  ]);

  const handleDisableButton = useCallback(() => {
    productDescription && productCode && productPrice !== "0,00"
      ? setDisabledAddButton(false)
      : setDisabledAddButton(true);
  }, [productCode, productDescription, productPrice, setDisabledAddButton]);

  const removeMaskDecimal = (value = "", fixed = 2) => {
    return parseFloat(
      parseFloat(value.replace(/\./g, "").replace(",", ".")).toFixed(fixed)
    );
  };

  const handleSelectCaixa = (setModalCaixa, selectedCaixa) => {
    if (!selectedCaixa[0])
      return notify("Selecione um terminal de caixa para continuar.");

    setSelectedCaixa(selectedCaixa[0]);

    setModalCaixa(false);
  };

  const handleSelectSeller = (setModalSeller, selectedSeller) => {
    setSellerInfos(selectedSeller[0]);

    setModalSeller(false);
  };

  const handleSelectClient = (setModalClient, selectedClient) => {
    setClientInfos(selectedClient[0]);

    setModalClient(false);
  };

  const handleSelectProduct = (setModalProduct, selectedProduct) => {
    const estoqueSobConsulta = verificaEstoqueSobConsulta(
      selectedProduct[0].estoques
    );

    if (!estoqueSobConsulta) {
      setProductInfos(selectedProduct[0]);
    }

    setModalProduct(false);
  };

  const handleChangeProductCode = useCallback(
    (e) => {
      let typedValue = e.target.value.replace(/[^A-Za-z0-9-.]+/g, "");

      setProductCode(typedValue);
      setProductCodeAux(typedValue);
    },
    [setProductCode, setProductCodeAux]
  );

  const handleChangeSellerCode = useCallback(
    (e) => {
      let typedValue = e.target.value.replace(/[^A-Za-z0-9-.]+/g, "");

      setSellerCodeAux(typedValue);
      setSellerCode(typedValue);
    },
    [setSellerCodeAux, setSellerCode]
  );

  const handleChangeClientCpf = useCallback(
    (e) => {
      let typedValue = e.target.value.replace(/[^0-9-./]+/g, "");

      setClientCpfAux(typedValue);
      setClientCpf(typedValue);
    },
    [setClientCpf, setClientCpfAux]
  );

  const deletePaymentRow = (index, valor, fn) => {
    if (!disabledPaymentActions) {
      Swal.fire({
        icon: "question",
        text: "Tem certeza que deseja remover o item?",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const copy = [...paymentRows];
          copy.splice(index, 1);

          //Reordenação dos Indexs
          copy.forEach((value, newIndex) => {
            value.index = newIndex;
            value.numero = newIndex + 1;
          });

          setPaymentRows(copy);

          setTotalPayment((oldValue) =>
            MaskService.toMask(
              "decimal",
              (removeMaskDecimal(oldValue) - removeMaskDecimal(valor)).toFixed(
                2
              )
            )
          );
          fn();
        }
      });
    }
  };

  const handleCalcItemsDiscount = useCallback(() => {
    let discount = 0;
    tableRows.forEach((value) => {
      discount += removeMaskDecimal(value.descvalor) * value.qtd;
    });

    setItemsDiscount(MaskService.toMask("decimal", discount.toFixed(2)));
  }, [tableRows, setItemsDiscount]);

  const handleCalcPaymentValue = useCallback(() => {
    let payd = 0;
    paymentRows.forEach((value) => {
      payd += removeMaskDecimal(value.valor);
    });

    let charge = removeMaskDecimal(toPayValue) - payd;
    setPaymentValue(MaskService.toMask("decimal", charge.toFixed(2)));
  }, [paymentRows, setPaymentValue, toPayValue]);

  const handleSellerObject = useCallback(() => {
    setSellerCode(sellerInfos?.id ?? "");
    setSellerName(sellerInfos?.apelido ?? "");
    setSellerCpfCnpj(sellerInfos?.cpfcnpj ?? "");
    setSellerComission(
      sellerInfos?.comissao
        ? MaskService.toMask(
            "decimal",
            parseFloat(sellerInfos?.comissao).toFixed(2)
          )
        : "0,00"
    );
  }, [
    sellerInfos,
    setSellerCode,
    setSellerName,
    setSellerCpfCnpj,
    setSellerComission,
  ]);

  const handleClientObject = useCallback(() => {
    if (!clientInfos?.id || !paymentTypes.length) return;

    setClientCpf(clientInfos?.cpfcnpj ?? "");
    setClientName(clientInfos?.razao ?? "VENDA CONSUMIDOR");
    setClientId(clientInfos?.id ?? 1);
    if (clientInfos?.id_tipopagamento) {
      const standardType = paymentTypes.find(
        (type) => type.id === clientInfos.id_tipopagamento
      );
      setSelectedPaymentType(standardType || null);
    } else {
      const standardType = paymentTypes.find((method) =>
        method.descricao.includes("Dinheiro")
      );
      setSelectedPaymentType(standardType || null);
    }
  }, [
    clientInfos,
    paymentTypes,
    setClientCpf,
    setClientName,
    setClientId,
    setSelectedPaymentType,
  ]);

  const handleClientMethopPayment = useCallback(() => {
    if (!clientInfos?.id || !paymentMethods.length) return;
    if (clientInfos?.idformapagto) {
      const standardMethod = paymentMethods.find(
        (method) =>
          method.id === clientInfos?.idformapagto ||
          method.descricao?.includes("A VISTA") ||
          method.descricao?.includes("1x")
      );
      setSelectedPaymentMethod(standardMethod || null);
    }
  }, [setSelectedPaymentMethod, clientInfos, paymentMethods]);

  const verificaEstoqueSobConsulta = useCallback((estoques) => {
    const verificaEstoque = estoques?.find(
      (estoques) => estoques.sobconsulta === "S"
    );

    if (verificaEstoque) {
      Swal.fire({
        icon: "error",
        text: "PRODUTO SOB CONSULTA, ENTRE EM CONTATO COM O SUPERVISOR!",
      });

      return true;
    } else {
      return false;
    }
  }, []);

  const handleProductObject = useCallback(() => {
    setProductCode(productInfos?.codigo || "");

    if (productInfos?.codbarras_codigoalternativo) {
      setProductDescription(
        productInfos?.descricaoresumida +
          " " +
          productInfos?.codbarras_codigoalternativo ?? ""
      );
    } else {
      setProductDescription(productInfos?.descricaoresumida ?? "");
    }

    const getProductPrice = () => {
      if (queryParams.paramprecoestoqueunico === "SIM") {
        return MaskService.toMask(
          "decimal",
          productInfos?.precovenda
            ? parseFloat(productInfos?.precovenda).toFixed(4)
            : "0.00",
          4
        );
      } else {
        return productInfos?.estoques[0]?.precovenda
          ? MaskService.toMask(
              "decimal",
              parseFloat(productInfos?.estoques[0]?.precovenda).toFixed(4),
              4
            )
          : "0,00";
      }
    };

    setProductPrice(getProductPrice());

    let discountProduct =
      productInfos?.perc_desc_codigoalternativo || clientInfos?.descporc || 0;
    let price = 0;
    if (queryParams.paramprecoestoqueunico === "SIM") {
      price = productInfos?.precovenda
        ? parseFloat(productInfos?.precovenda || 0).toFixed(2)
        : 0;
    } else {
      price = productInfos?.estoques[0]?.precovenda
        ? parseFloat(productInfos?.estoques[0]?.precovenda || 0).toFixed(2)
        : 0;
    }

    setProductDiscount(
      MaskService.toMask(
        "decimal",
        (price * (discountProduct / 100)).toFixed(2)
      )
    );
    setUpdatedValue(() => {
      if (queryParams.paramprecoestoqueunico === "SIM") {
        return MaskService.toMask(
          "decimal",
          productInfos?.precovenda
            ? parseFloat(productInfos?.precovenda).toFixed(2)
            : "0.00"
        );
      } else {
        return productInfos?.estoques[0]?.precovenda
          ? changeUStoBR(
              parseFloat(productInfos?.estoques[0]?.precovenda).toFixed(2)
            )
          : "0,00";
      }
    });
    setProductImage(
      productInfos?.produtosfotos?.length
        ? productInfos?.produtosfotos[0].s3_key ||
            productInfos?.produtosfotos[0].s3_keymin ||
            ""
        : ""
    );
    setProductStorageCode(
      productInfos?.estoques ? productInfos?.estoques[0].id : ""
    );
    setProductUnity(
      productInfos?.unidade_venda || productInfos?.unidade || "UN"
    );
    setProductQuantity(productInfos?.qtdvenda_codigoalternativo ?? 1);
    setProductConversionFactor(
      changeUStoBR(
        productInfos?.fator_conversao_venda
          ? parseFloat(productInfos?.fator_conversao_venda)
          : "0,00000"
      )
    );
    setProductBruteCost(
      MaskService.toMask(
        "decimal",
        parseFloat(
          (queryParams.paramprecoestoqueunico === "SIM"
            ? productInfos?.custobruto
            : productInfos?.estoques[0]?.custobruto) ||
            removeMaskDecimal(getProductPrice())
        ).toFixed(2)
      )
    );
  }, [
    productInfos,
    queryParams.paramprecoestoqueunico,
    setProductConversionFactor,
    setProductDescription,
    setProductImage,
    setProductPrice,
    setProductQuantity,
    setProductStorageCode,
    setProductUnity,
    setUpdatedValue,
    clientInfos?.descporc,
    setProductCode,
    setProductDiscount,
    setProductBruteCost,
  ]);

  const handleDeleteTableRows = (index, valor, valorDiscount) => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja remover o item?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
      confirmButtonText: "Sim",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const copy = [...tableRows];
        copy.splice(index, 1);

        //Reordenação dos Indexs
        copy.forEach((value, newIndex) => {
          value.index = newIndex;
        });

        setTableRows(copy);

        setOrderTotal((oldValue) =>
          MaskService.toMask(
            "decimal",
            (removeMaskDecimal(oldValue) - removeMaskDecimal(valor)).toFixed(2)
          )
        );
        setOrderTotalNoDiscount((oldValue) =>
          MaskService.toMask(
            "decimal",
            (
              removeMaskDecimal(oldValue) - removeMaskDecimal(valorDiscount)
            ).toFixed(2)
          )
        );
      }
    });
  };

  const handleAddTableRows = () => {
    if (!productDescription || !productCode) {
      return;
    }

    let row = {
      id: productCode,
      descricao: productDescription,
      qtd: productQuantity,
      precovenda: productPrice,
      valortotal: MaskService.toMask("decimal", updatedValue),
      index: tableRows.length,
      descvalor: productDiscount,
      idestoque: parseInt(productStorageCode),
      unidade: productUnity !== "" ? productUnity : "UN",
      fator_conversao_venda: productConversionFactor,
      precounitariocusto: productBruteCost,
    };

    setTableRows([...tableRows, row]);

    setOrderTotal((oldValue) =>
      MaskService.toMask(
        "decimal",
        (
          removeMaskDecimal(oldValue) + removeMaskDecimal(row.valortotal)
        ).toFixed(2)
      )
    );
    setOrderTotalNoDiscount((oldValue) =>
      MaskService.toMask(
        "decimal",
        (
          removeMaskDecimal(oldValue) + removeMaskDecimal(row.precovenda)
        ).toFixed(2)
      )
    );

    resetProductInputs();
  };

  const setStandardPayment = () => {
    const standardType = paymentTypes.find((method) =>
      method.descricao.includes("Dinheiro")
    );

    setSelectedPaymentType(standardType || null);
  };

  const makeBankAccountsList = useCallback(
    (data) => {
      var accountsList = [];

      data.forEach((item) => {
        let newIndex = {};

        newIndex = {
          descricao: `${item.bancos.codigo} - ${item.bancos.nome}`,
        };

        accountsList.push(newIndex);
      });

      setBankAccountsList(accountsList);
    },
    [setBankAccountsList]
  );

  const handleOpenFinishModal = () => {
    const validateSeller = validNotNull([
      {
        key: "sellerCode",
        value: sellerCode,
      },
      {
        key: "sellerName",
        value: sellerName,
      },
    ]);
    const validateClient = validNotNull([
      {
        key: "clientName",
        value: clientName,
      },
    ]);
    setSellerErrors({
      ...validateSeller.errorsValidation,
    });
    setClientErrors({
      ...validateClient.errorsValidation,
    });
    if (!validateSeller.error && !validateClient.error) {
      tableRows.length >= 1
        ? setModalFinishOpen(true)
        : notify("Você precisa adicionar ao menos um produto para prosseguir.");
    } else {
      notify("Verifique se os campos necessários foram preenchidos.");
    }
  };

  const handleFinishOrder = async (
    transmit = false,
    disableFinishButton = false,
    hideTransmitButton = false
  ) => {
    if (!selectedCaixa) {
      setDialogSelectCaixaOpen(true);
      return notify("Selecione um caixa para terminar.");
    }

    const jsonValidateFinish = [
      {
        key: "sellerCode",
        value: sellerCode,
      },
      {
        key: "clientId",
        value: clientId,
      },
    ];

    const validateFinishOrder = validNotNull(jsonValidateFinish);

    if (tableRows.length < 1) {
      setModalFinishOpen(false);
      return notify("Nenhum produto registrado.");
    }

    if (paymentRows.length < 1) {
      return notify("Nenhuma forma de pagamento registrada.");
    }

    if (removeMaskDecimal(totalPayment) < removeMaskDecimal(toPayValue)) {
      return notify("Pagamento recebido menor que o total a pagar.");
    }

    if (validateFinishOrder.error) {
      let notifyMsg = "";

      if (validateFinishOrder.errorsValidation.clientId) {
        notifyMsg = "Selecione um cliente válido.";
      }

      if (validateFinishOrder.errorsValidation.sellerCode) {
        notifyMsg = "Selecione um vendedor válido.";
      }

      setModalFinishOpen(false);
      return notify(notifyMsg);
    }

    // Verificação para limite de crédito
    let pagamentosCarteira = 0;
    let limiteAtual = clientInfos?.valor_limite || 0;
    paymentRows.forEach((payment) => {
      if (payment.carteira === "S") {
        pagamentosCarteira += parseFloat(payment.valor);
      }
    });

    // Se o cliente for usar o crédito, verifico se ele possui um limite
    // e se o ID do cliente é diferente do Venda Consumidor.
    if (pagamentosCarteira > 0 && clientInfos?.id !== 1) {
      try {
        setModalVrfLoading(true);

        // Consulto o crédito utilizado e o número de contas vencidas
        var [consultaCredito, consultaContas] = await Promise.all([
          consultCreditLimit({
            empresa_cnpj: queryParams.empresa_cnpj,
            clientId: clientInfos?.id,
          }),
          consultOverdueBills({
            empresa_cnpj: queryParams.empresa_cnpj,
            clientId: clientInfos?.id,
          }),
        ]);
      } catch (e) {
        console.error(e);
      } finally {
        setModalVrfLoading(false);
      }

      if (!consultaCredito?.success) {
        return notify("Ocorreu um erro ao consultar o crédito disponível.");
      }

      if (!consultaContas?.success) {
        return notify("Ocorreu um erro ao consultar as contas em atraso.");
      }

      let creditoUtilizado = parseFloat(consultaCredito.data.creditoUtilizado);

      // Objeto que engloba as restrições do cliente, caso a propriedade
      // esteja marcada como 'true', significa que o índice no objeto
      // de permissões também precisa estar true para prosseguir.
      const CLIENT_RESTRICTIONS = [
        {
          key: "LIBERA_RESTRICAO",
          value: (clientInfos?.restricao || "").toUpperCase() === "SIM",
          message: `O cliente possui restrição: ${
            clientInfos?.observacao || ""
          }.`,
        },
        {
          key: "LIBERA_VENDA_LIMITE_CREDITO",
          value:
            (clientInfos?.possui_limite || "") === "SIM" &&
            pagamentosCarteira > parseFloat(limiteAtual) - creditoUtilizado,
          message: "O cliente estourou seu limite de crédito disponível.",
        },
        {
          key: "LIBERA_VENDA_CONTA_ATRASO",
          value: !!consultaContas.data.overdueAccounts,
          message: "O cliente possui contas em atraso.",
        },
      ];

      const neededPermissions = CLIENT_RESTRICTIONS.filter((el) => el.value);
      if (neededPermissions.length) {
        let permissions;
        try {
          setModalVrfLoading(true);
          permissions = await findPermissionsForOrder({
            empresa_cnpj: queryParams.empresa_cnpj,
            userId: queryParams.usuario_id,
          });
        } catch (e) {
          console.error(e);
        } finally {
          setModalVrfLoading(false);
        }

        if (!permissions?.success) {
          return notify(
            "Ocorreu um erro ao consultar as permissões do usuário."
          );
        }

        const warnings = [];
        neededPermissions.forEach((permission) => {
          if (!permissions.data[permission.key]) warnings.push(permission);
        });

        if (warnings.length) {
          // abre o modal de autenticação
          setModalAuthenticateWarnings(warnings);
          setModalAuthenticateOpen(true);
          return;
        }

        let swal = await Swal.fire({
          icon: "info",
          text: "Você está prestes a liberar uma venda com crédito para um cliente que possui limite de crédito excedido. Deseja continuar?",
          showConfirmButton: true,
          confirmButtonText: "OK",
          showDenyButton: true,
          denyButtonText: "Cancelar",
        });

        if (swal.isDenied)
          return notify(
            "Altere a forma de pagamento para não usar o crédito e prosseguir com o pedido."
          );

        if (swal.isConfirmed) {
          var usuarioLiberou = queryParams.usuario_id;
        }
      }
    }
    if (pagamentosCarteira > 0 && clientInfos?.id === 1) {
      return notify("Venda possui pagamento a faturar. Selecione um cliente.");
    }
    await sendBody(
      generateBody(usuarioLiberou),
      transmit,
      disableFinishButton,
      hideTransmitButton
    );
  };

  const generateBody = (idusuario = undefined) => {
    let sellDate = new Date();

    let hour =
      sellDate.getHours() <= 9
        ? "0" + sellDate.getHours()
        : sellDate.getHours();

    let minutes =
      sellDate.getMinutes() <= 9
        ? "0" + sellDate.getMinutes()
        : sellDate.getMinutes();

    let seconds =
      sellDate.getSeconds() <= 9
        ? "0" + sellDate.getSeconds()
        : sellDate.getSeconds();

    let currentHours = hour + ":" + minutes;

    /**
     * (RATEIO NOVO)
     * Juntamente com o Júnior e a Rose, chegamos a conclusão que
     * o cálculo do rateio deve ser realizado da seguinte forma:
     *
     * (desconto geral / subtotal) * valor total original de cada item
     *
     * - Total original: precovendaoriginal - descontooriginal * quantidade;
     * - Desconto geral: desconto adicionado em cima do subtotal;
     * - Subtotal: Valor da venda sem descontos.
     *
     * E esses valores serão armazenados em 'vendas.vendasitens' na
     * coluna 'descgeralprop' (desconto geral proporcional)
     * para futuros relatórios.
     */
    const subTotal = removeMaskDecimal(orderTotal);
    const average = removeMaskDecimal(onTotalDiscount) / subTotal;

    let vendasitens = tableRows.map((row, i) => {
      // desconto original adicionado diretamente no item (desconto unitário)
      const descOriginal = removeMaskDecimal(row.descvalor);

      // preço original, no qual o usuário o define
      const precoVendaOriginal = removeMaskDecimal(row.precovenda);

      // porcentagem do desconto original baseado no preço de venda original
      const descPorcOriginal = (
        (descOriginal * 100) /
        precoVendaOriginal
      ).toFixed(5);

      // total original, se baseando apenas no item com desconto original
      const totalOriginal =
        (precoVendaOriginal - descOriginal) * parseFloat(row.qtd);

      // desconto geral proporcional: média do desconto geral * valor total do item (apenas com desconto unitario)
      const descGeralProp = average * totalOriginal;

      // valor do rateio + desconto original
      const descValor = descGeralProp / parseFloat(row.qtd) + descOriginal;

      // porcentagem de desconto juntamente com o desconto vindo do rateio
      const descPorc = (descValor / precoVendaOriginal) * 100;

      // preço unitário em que o produto foi vendido
      // (preço de venda original + todos os descontos)
      const precoUnitario = precoVendaOriginal - descValor;

      // preço total dos itens (valor do item com todos os
      // descontos * a quantidade de itens)
      const precoTotal = precoUnitario * parseFloat(row.qtd);

      let reuturnObj = {
        // Preços
        precounitariocusto: removeMaskDecimal(row.precounitariocusto),
        precototal: precoTotal,
        precounitario: precoUnitario,

        // Descontos
        descvalor: descValor,
        descporc: descPorc,
        descontooriginal: descOriginal,
        descontoporcoriginal: descPorcOriginal,
        desconto_geral_proporcional: descGeralProp,

        // Comissões ao vendedor
        comissao: precoTotal * (parseFloat(sellerComission) / 100),
        comissao1: precoTotal * (parseFloat(sellerComission) / 100),
        comissaoporc1: parseFloat(sellerComission),

        // Valores padrão
        qtde: row.qtd,
        idestoque: row.idestoque,
        precovendaoriginal: precoVendaOriginal,
        fator_conversao: parseFloat(row.fator_conversao_venda ?? "0,00000"),
        tipovenda: "venda",
        baixado: "S",
        formaentrega: "R",
        valorfrete: 0,
        unidade: row.unidade,
        numero_item: i + 1,
        sequencia: i + 1,
      };

      if (row.id) reuturnObj.id = row.id;

      return reuturnObj;
    });

    const formaspagtos = paymentRows.map((forma) => {
      let condicoes = [],
        i = 1,
        condicao = {},
        contasreceber = [],
        conta = {},
        previstorealizado = "",
        recebimento = {},
        cheque = {},
        cartao = {};

      let parcelasCondicoes = forma.parcelasCondicaoPgto;

      let rateio = parseFloat(
        (removeMaskDecimal(forma.valor) / forma.qtdparcelas).toFixed(2)
      );

      let summedRateio = 0;

      for (i; i <= forma.qtdparcelas; i++) {
        let dueDate = new Date();
        let fixedRateio = rateio;

        if (i === forma.qtdparcelas) {
          fixedRateio = parseFloat(
            (removeMaskDecimal(forma.valor) - summedRateio).toFixed(2)
          );
        } else {
          summedRateio = parseFloat((summedRateio + rateio).toFixed(2));
        }

        let parcelaAtual = parcelasCondicoes.find(
          // eslint-disable-next-line no-loop-func
          (item) => item.numParcela === i
        );

        dueDate.setDate(dueDate.getDate() + (parcelaAtual?.diaParcela || 0));

        condicao = {
          parcela: i,
          data: formatDate({
            date: dueDate,
            separator: "-",
            format: "yyyy-mm-dd",
          }),
        };

        previstorealizado = i === 1 ? "realizado" : "previsto";

        if (forma.indicador === "N" && i === 1) {
          recebimento = {
            idempresa: parseInt(queryParams.empresa_id),
            valorrecebido: fixedRateio,
            id_tipopagamento: forma.idtipopagto,
            idagencias: forma.agencia ?? null,
            quemlancou: "Qyon PDV",
            datahoralancou: `${formatDate({
              date: sellDate,
              separator: "-",
              format: "yyyy-mm-dd",
            })} ${currentHours}:${seconds}`,
            datarecebimento: formatDate({
              date: sellDate,
              separator: "-",
              format: "yyyy-mm-dd",
            }),
            idcliente: parseInt(clientId),
            formapagto: forma.formapagto,
            idcaixaterminais:
              forma?.conferecaxia !==
              GlobalVariables.paymentType.negativeCashConferenca
                ? selectedCaixa.id
                : null,
          };
        }

        if (forma.indicador === "N") {
          recebimento.valorrecebido = fixedRateio;
        }

        if (forma.cheque) {
          cheque = {
            sn_banco: forma.cheque.sn_banco,
            sn_conta: forma.cheque.sn_conta,
            sn_agencia: forma.cheque.sn_agencia,
            sn_correntista: forma.cheque.sn_correntista,
            sn_numero: forma.cheque.sn_numero,
            sn_cpfcgc: forma.cheque.sn_cpfcgc,
            dt_datadeposito: forma.cheque.dt_datadeposito,
          };
        }

        if (forma.cartao) {
          cartao = {
            sn_autorizacao: forma.cartao.sn_autorizacao,
            sn_docnsu: forma.cartao.sn_docnsu,
            id_operadora: forma.cartao.id_operadora,
            id_bandeira: forma.cartao.id_bandeira,
          };
        }

        conta = {
          idempresa: parseInt(queryParams.empresa_id),
          dataemissao: sellDate, //verificar
          datavencto: formatDate({
            date: dueDate,
            separator: "-",
            format: "yyyy-mm-dd",
          }),
          previstorealizado: previstorealizado, //ou previsto
          origem: "venda",
          valordocto: fixedRateio,
          idcliente: parseInt(clientId),
          recebimentos: { ...recebimento },
          idcaixaterminais: selectedCaixa.id,
          cheque: cheque,
          cartao: cartao,
        };

        // se o indice nao estiver populado, remove o índice
        if (!recebimento.idempresa) delete conta.recebimentos;
        if (!forma.cheque) delete conta.cheque;
        if (!forma.cartao) delete conta.cartao;

        condicoes.push(condicao);
        contasreceber.push(conta);
      }

      return {
        idformapagto: parseInt(forma.idformapagto),
        valor:
          removeMaskDecimal(forma.valor) - removeMaskDecimal(troco ? troco : 0),
        idtipopagto: parseInt(forma.idtipopagto),
        personalizado: "S",
        vendasformaspagtoscondicoes: condicoes,
        contasreceber: contasreceber,
      };
    });

    const discountValue = isPercentage
      ? (removeMaskDecimal(onTotalDiscount) / 100) *
        removeMaskDecimal(orderTotal)
      : removeMaskDecimal(onTotalDiscount);

    // ao salvar como orcamento, mudar o tipo para O e o statusvenda para "Orçamento"

    return {
      venda: {
        idempresa: parseInt(queryParams.empresa_id),
        cnpjempresa: queryParams.empresa_cnpj.replace(/\D/g, ""),
        idcliente: parseInt(clientId), //int
        idusuario: parseInt(queryParams.usuario_id),
        idusuarioliberou: idusuario ? parseInt(idusuario) : null,
        statusvenda: "Venda",
        observacao: "Pedido rápido",
        totalitens:
          removeMaskDecimal(orderTotal) + removeMaskDecimal(itemsDiscount),
        totalcusto:
          removeMaskDecimal(orderTotal) + removeMaskDecimal(itemsDiscount),
        totalgeral: removeMaskDecimal(toPayValue),
        idvendedor: parseInt(sellerCode), //any
        valordescgeral: discountValue,
        totaldesconto:
          removeMaskDecimal(itemsDiscount) + removeMaskDecimal(onTotalDiscount),
        totalsemdescontogeral: removeMaskDecimal(orderTotal),
        subtotal:
          removeMaskDecimal(orderTotal) + removeMaskDecimal(itemsDiscount),
        data: sellDate, //verificar
        horavenda: currentHours,
        tipo: "V",
        totalfrete: 0, //verificar
        totalcomissaoporc1: parseFloat(sellerComission),
        totalcomissao: (
          (parseFloat(sellerComission) / 100) *
          removeMaskDecimal(toPayValue)
        ).toFixed(2),
        porcdescgeral: (
          (removeMaskDecimal(onTotalDiscount) * 100) /
          removeMaskDecimal(orderTotal)
        ).toFixed(2),
        idsituacao: 1,
        orcamentofechado: "N",
        finalizadacaixa: "S",
        troco: removeMaskDecimal(troco),
        vendasitens: vendasitens,
        formaspagtos: formaspagtos,
        handleUpdate: true,
        gf_token: queryParams.gfAccessToken,
      },
    };
  };

  const sendBody = async (
    body,
    transmit = false,
    disableFinishButton = false,
    hideTransmitButton = false
  ) => {
    try {
      setModalVrfLoading(true);
      (async () => {
        let callback = null;
        if (tempQueryParams?.saleId) {
          callback = await updateVenda(
            tempQueryParams?.saleId,
            queryParams.empresa_cnpj,
            body
          );
        } else {
          callback = await createVenda(queryParams.empresa_cnpj, body);
        }

        const link =
          queryParams.current_url !== "localhost"
            ? `https://${queryParams.current_url}.qyon.com/`
            : `http://localhost/`;

        if (callback?.success) {
          setModalVrfLoading(false);

          if (transmit) {
            let cupomFiscal = selectedCaixa.tipo_cupom_fiscal;
            let terminalId = selectedCaixa.id;

            const { value: document } = await swalValidateCpfCnpj();

            let redirecionarNovoDfe = false;
            let baseUrl = "zf/vendas/nfe/emissao";

            try {
              const configurationResponse = await findConfigurationV3();

              redirecionarNovoDfe =
                configurationResponse?.data?.redirecionar_novo_dfe === 1;
            } catch (error) {
              console.error("Error on find configuration: ", error);
              notify("Erro ao verificar o redirecionamento para o novo DFE.");
            }

            if (redirecionarNovoDfe) {
              baseUrl = "zf/dfe";
            }

            if (cupomFiscal === "N") {
              window.open(
                `${link}${baseUrl}?saleId=${callback?.data?.id}&operation=salesOrder&clientDocument=${document}`,
                "_blank"
              );
            } else {
              window.open(
                `${link}ip/vendas/cupomfiscal_novo.php?idvenda=${
                  callback.data.id
                }&tipo_cupom_fiscal=${cupomFiscal}&pdv=true&id_terminal=${terminalId}${
                  document ? `&document=${document}` : ""
                }`,
                "_blank",
                "height=500,width=700"
              );
            }

            if (hideTransmitButton) setDisplayNoneTransmit(true);
          }

          Swal.fire({
            icon: "success",
            text: "Pedido registrado com sucesso!",
            showConfirmButton: true,
            confirmButtonText: "OK",
          });

          setStoredOrderCode(callback.data.id);
          if (disableFinishButton) setFinishButtonView(false);
          setButtonNewOrderView(true);
          setDisabledPaymentActions(true);
        } else {
          setModalVrfLoading(false);
          notify(
            "Erro ao registrar pedido. Verifique os dados e tente novamente."
          );
        }
      })();
    } catch (error) {
      console.error(error);
    }
  };

  const handleActionsAfterFinishOrder = async (
    orderId,
    transmit = false,
    print = false,
    removeTransmitButton = () => {}
  ) => {
    const link =
      queryParams.current_url !== "localhost"
        ? `https://${queryParams.current_url}.qyon.com/`
        : `http://localhost/`;

    if (transmit && orderId) {
      let cupomFiscal = selectedCaixa.tipo_cupom_fiscal;
      let terminalId = selectedCaixa.id;

      const { value: document } = await swalValidateCpfCnpj();

      let redirecionarNovoDfe = false;
      let baseUrl = "zf/vendas/nfe/emissao";

      try {
        const configurationResponse = await findConfigurationV3();

        redirecionarNovoDfe =
          configurationResponse?.data?.redirecionar_novo_dfe === 1;
      } catch (error) {
        console.error("Error on find configuration: ", error);
        notify("Erro ao verificar o redirecionamento para o novo DFE.");
      }

      if (redirecionarNovoDfe) {
        baseUrl = "zf/dfe";
      }

      if (cupomFiscal === "N") {
        window.open(
          `${link}${baseUrl}?saleId=${orderId}&operation=salesOrder&clientDocument=${document}`,
          "_blank"
        );
      } else {
        window.open(
          `${link}ip/vendas/cupomfiscal_novo.php?idvenda=${orderId}&tipo_cupom_fiscal=${cupomFiscal}&pdv=true&id_terminal=${terminalId}&${
            document ? `&document=${document}` : ""
          }`,
          "_blank",
          "height=500,width=700"
        );
      }

      removeTransmitButton(true);
    } else if (print && orderId) {
      window.open(
        `${link}zf/vendas/listavendas/gerarpdf/?id=${orderId}&type=cupom_pedido`,
        "_blank",
        "height=500,width=700"
      );
    } else {
      console.error("Ação não especificada.");
    }
  };

  const getDefaultClient = async () => {
    try {
      setIsLoading(true);
      const callback = await findCliente({
        empresa_cnpj: queryParams.empresa_cnpj,
        id: 1,
      });

      if (callback.success && callback.data) {
        setClientInfos(callback.data);
      } else {
        setClientInfos(null);
        notify(`Cliente Venda Consumidor não encontrado.`);
      }
    } catch (e) {
      console.error("Erro ao buscar cliente por Venda consumidor.");
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Caso o swal esteja sendo chamado dentro de um modal e você esteja com
   * algum problema com não conseguir focar no input presente no Swal,
   * adicione a prop disableEnforceFocus no modal.
   */
  const swalValidateCpfCnpj = async () => {
    return await Swal.fire({
      icon: "question",
      text: "Caso deseje CPF ou CNPJ na nota, digite-o abaixo, ou deixe o campo vazio caso não queira.",
      input: "text",
      inputValue: clientCpf.replace(/[^0-9a-zA-Z]/g, ""),
      showConfirmButton: true,
      confirmButtonText: "Prosseguir",
      focusConfirm: false,
      allowOutsideClick: false,
      inputValidator: async (result) => {
        let replacedValue = result.replace(/[^0-9a-zA-Z]/g, "");

        return new Promise((resolve) => {
          if (!result) resolve();

          if (
            replacedValue.length <= 11 &&
            MaskService.isValid("cpf", replacedValue)
          )
            resolve();

          if (
            replacedValue.length > 11 &&
            MaskService.isValid("cnpj", replacedValue)
          )
            resolve();

          resolve(`${replacedValue.length <= 11 ? "CPF" : "CNPJ"} inválido`);
        });
      },
    });
  };

  /**
   * Função executada ao iniciar a tela para recuperar os dados iniciais
   */
  const handleInitScreen = useCallback(
    async (setters) => {
      if (
        !queryParams?.empresa_cnpj ||
        !queryParams?.empresa_id ||
        !queryParams?.usuario_id ||
        !queryParams?.idversao
      )
        return;

      try {
        setIsLoading(true);

        const [
          caixaTerminais,
          operadoras,
          bandeiras,
          agencias,
          tiposPagto,
          usuario,
          clientePadrao,
        ] = await Promise.all([
          findCaixaTerminais(queryParams.empresa_cnpj, null, {
            idempresa: queryParams.empresa_id,
          }),
          findOperadoras(queryParams.empresa_cnpj),
          findBandeiras(queryParams.empresa_cnpj, {
            st_ativo: "S",
          }),
          findAgencia(
            queryParams?.empresa_cnpj,
            queryParams?.usuario_id,
            "banco"
          ),
          findTipoPagamento(
            queryParams.empresa_cnpj,
            {
              st_ativo: "S",
            },
            "empresasformaspgto,empresasformaspgto.parcelasCondicaoPgto"
          ),
          findUsuarios(queryParams.empresa_cnpj, queryParams.usuario_id),
          findCliente({
            empresa_cnpj: queryParams.empresa_cnpj,
            id: 1,
          }),
        ]);

        // Recupera os terminais de caixa, se tiver apenas um, já o seta
        if (caixaTerminais.data?.length === 1)
          setSelectedCaixa(caixaTerminais.data[0]);
        else if (caixaTerminais.data?.length > 1) {
          setters.setDataContent(caixaTerminais.data);
          setDialogSelectCaixaOpen(true);
        } else return notify("Nenhum terminal de caixa cadastrado.");

        // Lista de operadoras;
        if (operadoras.data) setCardOperadorasList(operadoras.data);

        // Lista de cartões;
        if (bandeiras.data) setCardBandeirasList(bandeiras.data);

        // Lista de tipos de pagamento;
        if (tiposPagto.data) {
          let selected = tiposPagto.data.find((tiposPagto) =>
            tiposPagto.descricao.includes("Dinheiro")
          );

          setPaymentTypes(tiposPagto.data);
          setSelectedPaymentType(selected ?? null);
        }

        if (agencias.data) setBankAccountsList(agencias.data);

        if (!usuario.success) throw new Error("Usuário não encontrado");

        // Guardo o desconto máximo permitido do usuário logado
        setUserMaximumDiscountPercentage(
          MaskService.toMask(
            "decimal",
            parseFloat(
              usuario.data?.descontomaximopermitido
                ? usuario.data.descontomaximopermitido
                : "0.00"
            ).toFixed(2)
          )
        );

        // Se não for ID Versão 16, busco o vendedor padrão vinculado ao
        // usuário, se não busco o vendedor padrão do sistema.
        const seller = await findVendedores({
          empresa_cnpj: queryParams.empresa_cnpj,
          id:
            queryParams?.idversao !== "16" ? usuario.data.idvendedor || 14 : 14,
        });

        if (!seller.success || seller.data?.ativo !== "S")
          notify(
            "Vendedor padrão não encontrado no sistema ou se encontra inativo.",
            true,
            "warning"
          );
        else setSellerInfos(seller.data);

        if (!clientePadrao.success) {
          notify("Cliente VENDA CONSUMIDOR não encontrado.");
          throw new Error("Erro ao buscar cliente padrão.");
        }

        setClientInfos(clientePadrao.data);

        await getSeller();
        if (tempQueryParams?.saleId) {
          var sell = await findVendas({
            empresa_cnpj: queryParams.empresa_cnpj,
            id: tempQueryParams?.saleId,
            include:
              "vendasitens.estoque.produto,vendasformaspagtos.formapagto, vendasformaspagtos.tipopagtos, cliente",
          });
          setSellerCode(sell?.data?.idvendedor);
          setToPayValue(
            MaskService.toMask(
              "decimal",
              parseFloat(sell?.data?.totalgeral).toFixed(2)
            )
          );
          setOrderTotal(
            MaskService.toMask(
              "decimal",
              parseFloat(sell?.data?.totalsemdescontogeral).toFixed(2)
            )
          );
          setOrderTotal(
            MaskService.toMask(
              "decimal",
              parseFloat(sell?.data?.totalsemdescontogeral).toFixed(2)
            )
          );
          setClientId(sell?.data?.idcliente);
          setClientCpf(sell?.data?.cliente?.cpfcnpj);
          setClientInfos(sell?.data?.cliente);

          if (sell?.data?.vendasitens) {
            let arrayItens = [];
            let discountItens = 0;
            sell.data.vendasitens.forEach((item, index) => {
              let row = {
                id: item.id,
                descricao: item?.estoque?.produto?.descricao ?? "",
                qtd: parseInt(item.qtde),
                precovenda: MaskService.toMask(
                  "decimal",
                  parseFloat(item.precovendaoriginal).toFixed(2)
                ),
                valortotal: MaskService.toMask(
                  "decimal",
                  parseFloat(item.precototal).toFixed(2)
                ),
                index: index,
                descvalor: MaskService.toMask(
                  "decimal",
                  parseFloat(item.descvalor).toFixed(2)
                ),
                idestoque: item.idestoque,
                unidade: item.unidade !== "" ? item.unidade : "UN",
                fator_conversao_venda: item.fator_conversao,
                precounitariocusto: MaskService.toMask(
                  "decimal",
                  parseFloat(item.precounitario).toFixed(2)
                ),
              };

              discountItens += parseFloat(item.descvalor).toFixed(2);

              arrayItens.push(row);
            });
            setTableRows(arrayItens);
            setItemsDiscount(MaskService.toMask("decimal", discountItens));
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    },
    [
      queryParams?.empresa_cnpj,
      queryParams?.empresa_id,
      queryParams?.usuario_id,
      queryParams?.idversao,
      setCardBandeirasList,
      setCardOperadorasList,
      setClientInfos,
      setDialogSelectCaixaOpen,
      setPaymentTypes,
      setSelectedCaixa,
      setSelectedPaymentType,
      setIsLoading,
      getSeller,
      setUserMaximumDiscountPercentage,
      setSellerInfos,
      setClientCpf,
      setClientId,
      setOnTotalDiscount,
      setOrderTotal,
      setPaymentRows,
      setSellerCode,
      setTableRows,
      setToPayValue,
      setTroco,
      tempQueryParams?.saleId,
    ]
  );

  const finishOrderWithoutRequisitions = async (idusuario = undefined) => {
    const body = generateBody(idusuario);

    await sendBody(body, false, true);
  };

  return {
    handleInitScreen,
    handleSelectSeller,
    handleSelectClient,
    handleSelectProduct,
    handleSelectCaixa,
    handleAddTableRows,
    handleDeleteTableRows,
    handleUpdatedValue,
    handleDisableButton,
    handleChangeProductCode,
    handleChangeSellerCode,
    handleChangeClientCpf,
    handleCalcPaymentValue,
    handleOnTotalDiscount,
    handleOpenFinishModal,
    handleFinishOrder,
    handleTotalPayment,
    handleSellerObject,
    handleProductObject,
    handleClientObject,
    handleActionsAfterFinishOrder,
    handleCalcItemsDiscount,
    resetModalCardOrCheck,
    editModalChequeCartao,
    editPaymentRow,
    makeBankAccountsList,
    addPaymentRow,
    addPaymentRowCheckOrCard,
    deletePaymentRow,
    resetPage,
    changeUStoBR,
    getDefaultClient,
    removeMaskDecimal,
    handleClientMethopPayment,
    verificaEstoqueSobConsulta,
    finishOrderWithoutRequisitions,
  };
}
